//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AppPermissionsUserGroupView from "./AppPermissionsUserGroupView.vue";
import AppPermissionsSetRoleList from "./AppPermissionsSetRoleList.vue";

export default {
    name: "AppEditPermissions",
    components: {
        AQModal,
        AQDialog,
        AppPermissionsUserGroupView,
        AppPermissionsSetRoleList,
        AQCard
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        item: {
            type: Object,
            default: () => {}
        },
        parentRole: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            headerActionsModel: [{ name: this.$t("appEditPermissions.remove"), id: "REMOVE" }],
            disableSave: false,
            vModelModal: false,
            roleDetailsOpened: false,
            selectedPermissions: [],
            initialPermissions: [],
            showRemoveConfirmation: false,
            isDisabled: false,
            isOwner: false,
            inheritedRoles: [],
            allPermissions: []
        };
    },
    computed: {
        hasInheritedPermissions() {
            return this.inheritedRoles && this.inheritedRoles.length;
        },
        getConfirmRemoveTitle() {
            return `${this.$t("appEditPermissions.remove")} "${this.value.name || (`${this.value.firstName} ${this.value.lastName}`)}"`;
        },
        getConfirmRemoveBody() {
            return this.$t("appEditPermissions.dialogBody",
                { type: this.value.type.toLowerCase(), permissionName: this.$t(`applicationPermissions.${this.parentRole}Role`) });
        },
        checkForModifPermissions() {
            return JSON.stringify(this.initialPermissions) === JSON.stringify(this.selectedPermissions);
        },
        hasSave() {
            return { label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"), disabled: this.checkForModifPermissions };
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.vModelModal = !!(newValue && newValue.constructor === Object && Object.keys(newValue).length);
            },
            immediate: true
        }
    },
    created() {
        this.getItemPermissions();
    },
    methods: {
        ...mapActions("apps", ["actGetPermissionsToUserGroup", "actEditPermissionsUserGroup"]),
        permissionRoleView(data) {
            this.roleDetailsOpened = data;
        },
        getAllPermissions(items) {
            this.allPermissions = items;
        },
        actionModal(action) {
            if (action === "save") {
                if (this.selectedPermissions.length) {
                    this.saveNewPermissionsRole();
                } else {
                    this.showRemoveConfirmation = true;
                }
            } else {
                this.$emit("input");
            }
        },
        getItemPermissions() {
            const dataType = { id: this.value.id, group: !this.value.email };
            this.actGetPermissionsToUserGroup(dataType).then(
                data => {
                    const translatedRoles = {};
                    const getRolePermissions = (v) => {
                        const permissions = [];
                        v.forEach(element => {
                            if (element.code) {
                                if (element.code === "INITIATOR" && element.id) {
                                    translatedRoles[element.id] = `${this.$t("applicationPermissions.INITIATORTitle")} "${element.name}"`;
                                    permissions.push(element.id);
                                } else {
                                    translatedRoles[element.code] = element.name;
                                    permissions.push(element.code);
                                }
                            } else {
                                permissions.push(element);
                            }
                        });
                        return permissions;
                    };
                    this.selectedPermissions = data.data.directRoles.map(({ code, id }) => (code === "INITIATOR" && id ? id : code));
                    this.initialPermissions = [...data.data.directRoles];
                    this.isOwner = this.selectedPermissions.includes("OWNER");
                    this.inheritedRoles = data.data.inheritedRoles.map(element => ({
                        name: element.innerGrouDetails[0].groupName,
                        id: element.innerGrouDetails[0].groupId,
                        systemType: element.innerGrouDetails[0].systemType,
                        permissions: getRolePermissions(element.roles),
                        translatedRoles
                    }));
                }
            );
        },
        actionRemoveUser(remove) {
            if (remove) {
                this.saveNewPermissionsRole();
            }
            this.showRemoveConfirmation = false;
        },
        saveNewPermissionsRole() {
            const payloadSelectedPermissions = this.selectedPermissions.filter(role => role !== "OWNER");
            const roles = payloadSelectedPermissions.map(permission => {
                const permissionToSave = this.allPermissions.find(({ code, id }) => code === permission || id === permission);
                return permissionToSave;
            });

            const newPermissions = {
                permissionType: "PROCESS_DEFINITION",
                roles,
                [this.value.email ? "userId" : "groupId"]: this.value.id
            };
            this.actEditPermissionsUserGroup(newPermissions).then(
                () => {
                    if (this.selectedPermissions.length) {
                        this.$emit("input", {});
                        this.setNotification("saveEditPermission");
                    } else {
                        this.$emit("removePermission", this.value.id);
                        this.$emit("input");
                        this.setNotification("removeEditPermission");
                    }
                }
            );
        },
        setNotification(message) {
            this.$toast.showNotify({
                type: "success",
                message: this.$t(`appEditPermissions.${message}`)
            });
        }
    }
};
